import { IconArrowRight } from '@sympla/sympla-components/NavigationIcons';
import { cardVariants } from 'constants/search';
import * as El from './ShowMoreCard.css';
import locales from './_locales/ShowMoreCard.json';

interface ShowMoreCardProps {
  cardType: El.CardType;
  lang: 'PT' | 'ES' | 'EN';
  href: string;
}

function ShowMoreCard({ cardType, lang = 'PT', href = '#' }: ShowMoreCardProps) {
  return (
    <a href={href} className={El.showMoreContainerVariant[cardType]}>
      {cardType === cardVariants.collectionCard ? (
        <span className={El.textStyle}>{locales[lang].SEE_MORE_TEXT_3}</span>
      ) : (
        <>
          <span className={El.textStyle}>{locales[lang].SEE_MORE_TEXT_1}</span>
          <span className={El.textStyle}>{locales[lang].SEE_MORE_TEXT_2}</span>
        </>
      )}
      <IconArrowRight className={El.IconStyle} />
    </a>
  );
}

export default ShowMoreCard;
